<template>
	<div>
		<div v-for="(item,index) in zzjCoupons" :key="index" class="discount"  v-if="index < 3">
      <div class="storeCoupon" v-if="item.indexOf('满N件折') != -1">
        {{item}}
      </div>
      <div class="ticketCoupon" v-if="item.indexOf('店铺促销') != -1">
        {{item}}
      </div>
      <div class="redPro" v-if="item.indexOf('满额减') != -1 || item.indexOf('店铺活动') != -1">
        {{item}}
      </div>
      <div class="goodsCoupon" v-if="item.indexOf('领券') != -1">
        {{item}}
      </div>
      <div class="ticketCoupon" v-if="item.indexOf('淘客') != -1">
        {{item}}
      </div>
      <div class="goodsCoupon" v-if="item.indexOf('优惠券') != -1">
        {{item}}
      </div>
      <div class="redPro" v-if="item.indexOf('活动') != -1">
        {{item}}
      </div>
      <div class="storeCoupon" v-if="item.indexOf('跨店满减') != -1">
        {{item}}
      </div>
      <div class="sellPurple" v-if="item.indexOf('预售') != -1">
        {{item}}
      </div>
      <div class="categoryShoppingCoupon" v-if="item.indexOf('品类购物券') != -1">
        {{item}}
      </div>
      <div class="grayShop"  v-if="item.indexOf('自定义') != -1 || item.indexOf('关注店铺券') != -1">
        {{item}}
      </div>
      <div class="redPro" v-if="item.indexOf('官方立减') != -1">
        {{item}}
      </div>
    </div>
    <!-- 优惠券超出部分 -->
    <el-popover placement="top" width="320" trigger="hover">
      <div style="max-height: 240px;overflow:auto;">
        <div v-for="(item,index) in zzjCoupons" :key="index" style="text-align: center;font-size: 12px; color: white;margin-bottom: 7px;line-height: 20px;float: left;margin-right: 20px;">
          <div class="storeCoupon" v-if="item.indexOf('满N件折') != -1">
            {{item}}
          </div>
          <div class="ticketCoupon" v-if="item.indexOf('店铺促销') != -1">
            {{item}}
          </div>
          <div class="redPro" v-if="item.indexOf('满额减') != -1 || item.indexOf('店铺活动') != -1">
            {{item}}
          </div>
          <div class="goodsCoupon" v-if="item.indexOf('领券') != -1">
            {{item}}
          </div>
          <div class="ticketCoupon" v-if="item.indexOf('淘客') != -1">
            {{item}}
          </div>
          <div class="goodsCoupon" v-if="item.indexOf('优惠券') != -1">
            {{item}}
          </div>
          <div class="redPro" v-if="item.indexOf('活动') != -1">
            {{item}}
          </div>
          <div class="storeCoupon" v-if="item.indexOf('跨店满减') != -1">
            {{item}}
          </div>
          <div class="sellPurple" v-if="item.indexOf('预售') != -1">
            {{item}}
          </div>
          <div class="categoryShoppingCoupon" v-if="item.indexOf('品类购物券') != -1">
            {{item}}
          </div>
          <div class="grayShop"  v-if="item.indexOf('自定义') != -1 || item.indexOf('关注店铺券') != -1">
            {{item}}
          </div>
          <div class="redPro" v-if="item.indexOf('官方立减') != -1">
            {{item}}
          </div>
        </div>
      </div>
      <i class="el-icon-more" slot="reference" style="margin-top: 40px;margin-left: 5px;" v-show="zzjCoupons && zzjCoupons.length > 4"></i>
    </el-popover>
	</div>
</template>
<script>
export default {
	name:'couponsZzj',
	props:["zzjCoupons"],
}
</script>
<style lang="scss" scoped>
 .discount {
    text-align: center;
    font-size: 12px;
    color: white;
    margin-bottom: 7px;
    line-height: 20px;
    float: left;
    clear: both;
  }
</style>